<template>
  <Switches v-bind="$attrs" v-model="isEnabled"></Switches>
</template>

<script>
import Switches from 'vue-switches'

export default {
  components: {
    Switches,
  },
  props: {
    isSwitched: {},
  },
  data() {
    return {
      isEnabled: this.isSwitched,
    }
  },
  watch: {
    isEnabled() {
      this.$emit('handle-switch', this.isEnabled)
    },
  },
}
</script>

<style lang="scss">
.vue-switcher-theme--custom {
  align-items: center;
  max-width: fit-content;

  .vue-switcher__label {
    font-size: 13px;
    color: $mep-color-text;
  }
  div {
    background-color: $mep-primary-400;
    top: -6px;

    &:after {
      // for the circle on the switch
      background-color: $white;
    }
  }

  &.vue-switcher--unchecked {
    div {
      background-color: transparent;
      border-style: solid;
      border-width: 1px;
      border-color: #99a1b1;

      &:after {
        background-color: #99a1b1;
      }
    }
  }
}
</style>
